var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "card search-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-sm-3 col-md" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("流程名稱")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.search.Name,
                      expression: "search.Name",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "請輸入關鍵字" },
                  domProps: { value: _vm.search.Name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.search, "Name", $event.target.value.trim())
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("是否啟用")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { display: "block" },
                      attrs: { placeholder: "請選擇", clearable: "" },
                      model: {
                        value: _vm.search.IsEnabled,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "IsEnabled", $$v)
                        },
                        expression: "search.IsEnabled",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "是", value: true } }),
                      _c("el-option", { attrs: { label: "否", value: false } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-4" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { "margin-top": "30px", "margin-right": "5px" },
                  attrs: { type: "button" },
                  on: { click: _vm.getFlowSource },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("BUTTON.SEARCH")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  staticStyle: { "margin-top": "30px", "margin-right": "5px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.search = {}
                    },
                  },
                },
                [_vm._v(" 清除 ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "function-card" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary mr-2",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                _vm.dialogVisible = true
              },
            },
          },
          [_vm._v(" 階段資料維護 ")]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.openSettingModal({ action: "add" })
              },
            },
          },
          [_vm._v(" 新增流程 ")]
        ),
      ]),
      _c(
        "div",
        { staticClass: "yahome-table-wrap" },
        [
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.rows } },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticClass: "d-row header" }, [
                          _c("div", [_vm._v("階段名稱")]),
                          _c("div", [_vm._v("建議時間")]),
                          _c("div", [_vm._v("類型")]),
                          _c("div", [_vm._v("主管類型")]),
                        ]),
                        _vm._l(props.row.Stages, function (element, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "d-row" },
                            [
                              _c("div", [
                                _vm._v(" " + _vm._s(element.Name) + " "),
                              ]),
                              _c("div", [
                                _vm._v(" " + _vm._s(element.SugMinutes) + " "),
                              ]),
                              _c("div", [
                                _vm._v(" " + _vm._s(element.TypeString) + " "),
                              ]),
                              _c("div", [
                                _vm._v(
                                  " " + _vm._s(element.InterviewUserType) + " "
                                ),
                              ]),
                            ]
                          )
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "面談流程名稱", prop: "Name" },
              }),
              _c("el-table-column", {
                attrs: { label: "啟用" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        props.row.IsEnabled
                          ? _c(
                              "svg",
                              {
                                attrs: {
                                  width: "23",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 512 512",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M 400.6 173.4 c 12.5 12.5 12.5 32.8 0 45.3 l -188 188 c -12.5 12.5 -32.8 12.5 -45.3 0 l -100 -100 c -12.5 -12.5 -12.5 -32.8 0 -45.3 s 32.8 -12.5 45.3 0 L 192 338.7 L 355 173 c 12.5 -12.5 32.8 -12.5 45.3 0 z",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        !props.row.IsEnabled
                          ? _c(
                              "svg",
                              {
                                attrs: {
                                  width: "15",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 320 512",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-danger btn-sm mr-2",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.showDeleteFlowDialog(props.row)
                              },
                            },
                          },
                          [_vm._v(" 刪除 ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.openSettingModal({
                                  action: "edit",
                                  data: props.row,
                                })
                              },
                            },
                          },
                          [_vm._v(" 維護 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "settingModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered" },
            [
              _c(
                "ValidationObserver",
                { ref: "settingModal", staticClass: "modal-content" },
                [
                  _c(
                    "form",
                    {
                      on: {
                        reset: function ($event) {
                          $event.preventDefault()
                          return _vm.reset.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "modal-header" }, [
                        _vm.isAddSetting
                          ? _c("span", [_vm._v("新增流程")])
                          : _c("span", [_vm._v("編輯流程")]),
                      ]),
                      _c("div", { staticClass: "modal-body" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("label", { attrs: { for: "" } }, [
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("*"),
                                        ]),
                                        _vm._v(" 流程名稱 "),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v("(不可重複)")]
                                        ),
                                      ]),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.trim",
                                            value: _vm.settingModal.Name,
                                            expression: "settingModal.Name",
                                            modifiers: { trim: true },
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "text" },
                                        domProps: {
                                          value: _vm.settingModal.Name,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.settingModal,
                                              "Name",
                                              $event.target.value.trim()
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.$forceUpdate()
                                          },
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v(" " + _vm._s(errors[0]) + " ")]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-6" },
                            [
                              _c("div", { staticClass: "text-center" }, [
                                _vm._v("已選取項目"),
                              ]),
                              _c(
                                "draggable",
                                {
                                  staticClass: "drog-list draggableSelect",
                                  attrs: {
                                    list: _vm.settingModal.Stages,
                                    group: "stageList",
                                    move: _vm.handleMove,
                                  },
                                  on: { add: _vm.onAdd },
                                },
                                _vm._l(
                                  _vm.settingModal.Stages,
                                  function (element, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "d-item" },
                                      [
                                        _vm._v(
                                          " " + _vm._s(element.Name) + " "
                                        ),
                                        element.InterviewUserType
                                          ? [
                                              _c("br"),
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    element.InterviewUserType
                                                  ) +
                                                  ") "
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-6" },
                            [
                              _c("div", { staticClass: "text-center" }, [
                                _vm._v("未選取項目"),
                              ]),
                              _c(
                                "draggable",
                                {
                                  staticClass: "drog-list undraggableSelect",
                                  attrs: {
                                    list: _vm.unselectStageList,
                                    group: "stageList",
                                  },
                                },
                                _vm._l(
                                  _vm.unselectStageList,
                                  function (element, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "d-item" },
                                      [
                                        _vm._v(
                                          " " + _vm._s(element.Name) + " "
                                        ),
                                        element.InterviewUserType
                                          ? [
                                              _c("br"),
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    element.InterviewUserType
                                                  ) +
                                                  ") "
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(" 狀態 "),
                            ]),
                            _c("el-switch", {
                              staticStyle: { display: "block" },
                              attrs: {
                                "active-color": "#409eff",
                                "inactive-color": "#ccc",
                                "active-text": "啟用",
                                "inactive-text": "未啟用",
                              },
                              model: {
                                value: _vm.settingModal.IsEnabled,
                                callback: function ($$v) {
                                  _vm.$set(_vm.settingModal, "IsEnabled", $$v)
                                },
                                expression: "settingModal.IsEnabled",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: { type: "reset", "data-dismiss": "modal" },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.i18n("Buttons.Cancel")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            attrs: { type: "button" },
                            on: { click: _vm.saveFlowSource },
                          },
                          [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Save")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "階段設定",
            visible: _vm.dialogVisible,
            width: "680px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "text-right mb-2" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.showStageDialog()
                    },
                  },
                },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.stageList } },
            [
              _c("el-table-column", {
                attrs: { prop: "Name", label: "階段名稱" },
              }),
              _c("el-table-column", {
                attrs: { prop: "type", label: "類型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        props.row.Type === 1
                          ? _c("span", [_vm._v("考試")])
                          : _vm._e(),
                        props.row.Type === 2
                          ? _c("span", [_vm._v("面試")])
                          : _vm._e(),
                        props.row.Type === 3
                          ? _c("span", [_vm._v("問卷填寫")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "SugMinutes", label: "建議時間" },
              }),
              _c("el-table-column", {
                attrs: { prop: "InterviewUserType", label: "主管類型" },
              }),
              _c("el-table-column", {
                attrs: { width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.showDeleteStageDialog(props.row)
                              },
                            },
                          },
                          [_vm._v("刪除")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.showStageDialog(props.row)
                              },
                            },
                          },
                          [_vm._v("維護")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("關閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "刪除",
            visible: _vm.deleteFlowDialogVisible,
            width: "480px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteFlowDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _vm._v(" 是否確定刪除"),
            _c(
              "span",
              { staticStyle: { color: "#ff0000", "font-weight": "bold" } },
              [_vm._v(_vm._s(_vm.currentItem.Name))]
            ),
            _vm._v("？ "),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.deleteFlowDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteFlow()
                    },
                  },
                },
                [_vm._v("確定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "刪除",
            visible: _vm.deleteStageDialogVisible,
            width: "480px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteStageDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _vm._v(" 是否確定刪除"),
            _c(
              "span",
              { staticStyle: { color: "#ff0000", "font-weight": "bold" } },
              [_vm._v(_vm._s(_vm.currentItem.Name))]
            ),
            _vm._v("？ "),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.deleteStageDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteStage()
                    },
                  },
                },
                [_vm._v("確定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "階段",
            "destroy-on-close": "",
            visible: _vm.stageDialogVisible,
            width: "680px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.stageDialogVisible = $event
            },
          },
        },
        [
          _c("ValidationObserver", {
            ref: "settingModal",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ handleSubmit }) {
                  return [
                    _c("form", [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("label", { attrs: { for: "" } }, [
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("*"),
                                        ]),
                                        _vm._v(" 階段名稱 "),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v("(不可重複)")]
                                        ),
                                      ]),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.trim",
                                            value: _vm.stageModal.Name,
                                            expression: "stageModal.Name",
                                            modifiers: { trim: true },
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "text" },
                                        domProps: {
                                          value: _vm.stageModal.Name,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.stageModal,
                                              "Name",
                                              $event.target.value.trim()
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.$forceUpdate()
                                          },
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v(" " + _vm._s(errors[0]) + " ")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("label", { attrs: { for: "" } }, [
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("*"),
                                        ]),
                                        _vm._v("類型 "),
                                      ]),
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: "請選擇",
                                            disabled: _vm.stageModal.Guid,
                                          },
                                          model: {
                                            value: _vm.stageModal.Type,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.stageModal,
                                                "Type",
                                                $$v
                                              )
                                            },
                                            expression: "stageModal.Type",
                                          },
                                        },
                                        _vm._l(
                                          _vm.stageTypeList,
                                          function (option) {
                                            return _c("el-option", {
                                              key: option.Value,
                                              attrs: {
                                                label: option.Text,
                                                value: option.Value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v(" " + _vm._s(errors[0]) + " ")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("ValidationProvider", {
                            attrs: { name: "建議時間", rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("label", { attrs: { for: "" } }, [
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("*"),
                                        ]),
                                        _vm._v(" 建議時間 "),
                                      ]),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.trim",
                                            value: _vm.stageModal.SugMinutes,
                                            expression: "stageModal.SugMinutes",
                                            modifiers: { trim: true },
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "number",
                                          max: "120",
                                          min: "1",
                                        },
                                        domProps: {
                                          value: _vm.stageModal.SugMinutes,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.stageModal,
                                              "SugMinutes",
                                              $event.target.value.trim()
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.$forceUpdate()
                                          },
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v(" " + _vm._s(errors[0]) + " ")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm.stageModal.Type === 2
                        ? _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("ValidationProvider", {
                                attrs: { name: "主管類型", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("label", { attrs: { for: "" } }, [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(" 主管類型 "),
                                          ]),
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                placeholder: "請選擇",
                                                disabled: _vm.stageModal.Guid,
                                              },
                                              model: {
                                                value:
                                                  _vm.stageModal
                                                    .InterviewUserType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.stageModal,
                                                    "InterviewUserType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "stageModal.InterviewUserType",
                                              },
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: "單位面試主管",
                                                  value: "單位面試主管",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "HR面試人員",
                                                  value: "HR面試人員",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _c(
                      "span",
                      { staticClass: "dialog-footer" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.stageDialogVisible = false
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return handleSubmit(_vm.saveStage)
                              },
                            },
                          },
                          [_vm._v("儲存")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }